import { StepProps, TitleAndDescriptionProps, StepWizardProps } from '../../common/BaseStep';

export interface PaymentPageStepProps extends TitleAndDescriptionProps, StepProps, StepWizardProps {
  showCouponInput?: boolean;
}

export enum PaymentMethod {
  CreditCard = 'creditCard',
  PayPal = 'payPal',
}

export enum couponResult {
  Success = 'success',
  Invalid = 'invalid',
}

export interface SubscriptionPlan {
  id: string;
  description: string;
}

export interface Discount {
  code: string;
  coupon: {
    duration: string;
    percentOff: number;
    amountOff: number;
  };
}

export interface PayPalFormProps {
  plans: SubscriptionPlan[];
  goNext: () => void;
  discount: Discount;
  trialDays: number;
}

export interface PayPalScriptProviderProps extends PayPalFormProps {
  clientId: string;
}
